import { getToken } from '@ctsu/loader';

const bindLogger = (fn, ctx) => (...args) => {
  const token = getToken();

  const captureError = function New(error) {
    const { logError } = ctx;
    return logError(ctx, 'An Error Occured in Regulatory Application', JSON.stringify(error), null);
  };

  const { logError } = ctx;
  const { ...loggerInfo } = { logError, captureError };

  const boundLogger = function New(input) {
    return fn(token, loggerInfo, ...input);
  };

  return boundLogger(args);
};

export default bindLogger;
